var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center rounded-full select-none text-whiteOverride",class:[_vm.variantClass, _vm.sizeClass],attrs:{"data-test":"indicator"}},[_c('FontIcon',{attrs:{"data-test":"icon","name":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }